import { useState } from "react";
import { type EditorOps } from "./editorCore";

export const useCrop = (ops: EditorOps, setOps: (ops: EditorOps) => void) => {
  const [cropStart, setCropStart] = useState<{ x: number; y: number } | null>(
    null
  );
  const [cropEnd, setCropEnd] = useState<{ x: number; y: number } | null>(null);

  const onMouseDown = (x: number, y: number) => setCropStart({ x, y });
  const onMouseMove = (x: number, y: number) =>
    cropStart && setCropEnd({ x, y });
  const onMouseUp = () => {
    if (!cropStart || !cropEnd) return;
    setOps({
      ...ops,
      recorte: {
        x: Math.min(cropStart.x, cropEnd.x),
        y: Math.min(cropStart.y, cropEnd.y),
        width: Math.abs(cropEnd.x - cropStart.x),
        height: Math.abs(cropEnd.y - cropStart.y),
      },
    });
    setCropStart(null);
    setCropEnd(null);
  };

  const renderOverlay = (ctx: CanvasRenderingContext2D) => {
    if (cropStart && cropEnd) {
      ctx.strokeStyle = "red";
      ctx.strokeRect(
        cropStart.x,
        cropStart.y,
        cropEnd.x - cropStart.x,
        cropEnd.y - cropStart.y
      );
    }
  };

  const control = (
    <div>
      <p>Arrastra sobre la imagen para recortar</p>
      {ops.recorte && (
        <button
          className="btn btn-default"
          onClick={() => setOps({ ...ops, recorte: undefined })}
        >
          Reset Recorte
        </button>
      )}
    </div>
  );

  return { control, onMouseDown, onMouseMove, onMouseUp, renderOverlay };
};
